module.exports = __webpack_public_path__ + "img/case1.f2923f65.png";